/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleVersionCreateRequest } from './moduleVersionCreateRequest';

export type CreateModuleVersionBody = ModuleVersionCreateRequest | null;
